export default {
  siteName: 'פולאריס',
  back: 'לחזור',
  logout: 'התנתק',
  continue: 'להמשיך',
  update: 'עדכן',
  save: 'שמור',
  cancel: 'ביטול',
  approve: 'מאשר',
  close: 'סגור',
  yes: 'כן',
  no: 'לא',
  in: 'ב',
  and: 'ו',
  male: 'זכר',
  female: 'נקבה',
  days: {
    sunday: 'ראשון',
    monday: 'שני',
    tuesday: 'שלישי',
    wednesday: 'רביעי',
    thursday: 'חמישי',
    friday: 'שישי',
    saturday: 'שבת',
  },
  months: {
    january: 'ינואר',
    february: 'פברואר',
    march: 'מרץ',
    april: 'אפריל',
    may: 'מאי',
    june: 'יוני',
    july: 'יולי',
    august: 'אוגוסט',
    september: 'ספטמבר',
    october: 'אוקטובר',
    november: 'נובמבר',
    december: 'דצמבר',
  },
  validations: {
    required: 'שדה חובה',
    email: 'יש להזין מייל תקין',
    hebrew: 'יש להזין אותיות בעברית בלבד',
    characters: 'יש להזין אותיות בלבד',
    uid: 'יש להזין תעודת זהות תקינה',
    date: 'יש להזין תאריך תקין',
    number: 'ניתן להזין ספרות בלבד',
    mobile: 'יש להזין מספר טלפון נייד תקין',
    phone: 'יש להזין טלפון תקין',
    autocomplete: 'חובה לבחור פריט מהרשימה',
  },
  buildingTypes: {
    building: 'בניין',
    house: 'בית פרטי',
  },
};
